@let isMenuOpenValue = isMenuOpen();

<div class="header-utilities-menu">
  <i
    class="header-utilities-menu__icon fa-regular fa-ellipsis fa--header-texticon"
    [class.header-utilities-menu__icon--active]="isMenuOpenValue"
    (click)="toggleMenu()"
  >
    @if (unreadNotificationsCount() > 0) {
      <span class="header-utilities-menu__unread-notifications-indicator"></span>
    }
  </i>

  @if (isMenuOpenValue) {
    <itc-header-utilities-panel [(isOpen)]="isMenuOpen" />
  }
</div>
